import { Changes } from '../types';

// parse to string
function transformChanges(changes?: Changes) {
  if (changes) {
    const { name, oldValue, value } = changes;

    return {
      ...(name ? { name: String(name) } : undefined),
      ...(oldValue ? { oldValue: String(oldValue) } : undefined),
      ...(value ? { value: String(value) } : undefined),
    };
  }

  return changes;
}

function transformChangesArray(changes?: Changes[]) {
  return changes?.map((change) => {
    return transformChanges(change);
  });
}

export { transformChanges, transformChangesArray };
